export default {
  dev: {
    name: 'casetify-dev',
    appId: 'wxd0c71d6bf928a416',
    wechatId: '260',
  },
  stg: {
    name: 'casetify-stg',
    appId: 'wx5b54937843136dff',
    wechatId: '260',
  },
  prod: {
    name: 'casetify-prod',
    appId: 'wxd0c71d6bf928a416',
    wechatId: '260',
  }
};